import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';
import * as styles from './GlobalNav.module.styl';
import Button from '../Button';
import MenuItem from './MenuItem';
import SubMenu from './SubMenu';
import MobileMenu from './MobileMenu';
import useSiteSettings from '../../utils/useSiteSettings';
import { FiMenu, FiX } from 'react-icons/fi';

const menu = [
  {
    title: 'Go to Paperform',
    link_url: '/',
    sub_menu: null,
    featured_item: {
      title: '',
      description: '',
      image: null,
      link: {
        link_text: '#',
        link_url: '#',
      },
    },
  },
  {
    featured_item: {
      description: '',
      image: null,
      link: {
        link_text: '',
        link_url: '',
      },
      title: '',
    },
    link_url: 'https://paperform.co/products/papersign/#pricing',
    sub_menu: null,
    title: 'Pricing',
  },
  {
    title: 'Solutions',
    link_url: '/solutions/',
    sub_menu: [
      {
        title: 'Human Resources',
        link_url:
          'https://paperform.co/products/papersign/solutions/human-resources/',
        description: null,
      },
      {
        title: 'Real Estate',
        link_url:
          'https://paperform.co/products/papersign/solutions/real-estate/',
        description: null,
      },
      {
        title: 'Sales',
        link_url: 'https://paperform.co/products/papersign/solutions/sales/',
        description: null,
      },
      {
        title: 'Small Business',
        link_url:
          'https://paperform.co/products/papersign/solutions/small-business/',
        description: null,
      },
    ],
    featured_item: {
      title: '',
      description: '',
      image: null,
      link: {
        link_text: '#',
        link_url: '#',
      },
    },
  },

  {
    title: 'Free PDF Templates',
    link_url: '/pdf-templates/',
    sub_menu: null,
    featured_item: {
      title: '',
      description: '',
      image: null,
      link: {
        link_text: '#',
        link_url: '#',
      },
    },
  },
  {
    title: 'Resources',
    link_url: '/resources/',
    sub_menu: [
      {
        title: 'Blog',
        link_url: '/blog/',
        description:
          'Real-life stories, trends, and strategies to help you grow your business.',
      },
      {
        title: 'Careers',
        link_url: '/jobs/',
        description: "Join the company that prioritises 'life-work' balance.",
      },
    ],
    help_menu: [
      {
        title: 'Getting Started with Papersign',
        link_url:
          'https://paperform.co/help/articles/getting-started-with-papersign/',
        description: 'Helpful guides to get you on track.',
      },
      {
        title: 'Help Center',
        link_url: '/help/',
        description: "We've got all the answers to your questions.",
      },
    ],
  },
  {
    title: 'Sign in',
    link_url: '/sign',
    sub_menu: null,
    featured_item: {
      title: '',
      description: '',
      image: null,
      link: {
        link_text: '#',
        link_url: '#',
      },
    },
  },
];

const Nav2 = ({ fixed, invert, isTry }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState('');
  const menuItems = menu;
  const { register_button_text_papersign } = useSiteSettings();
  const registerText = register_button_text_papersign || 'Get Papersign Free';

  useEffect(() => {
    document.body.classList.toggle('menu-open', menuOpen);
  }, [menuOpen]);

  return (
    <>
      <div
        className={classnames(
          styles.wrapper,
          fixed && styles.fixed,
          invert && styles.inverted,
          menuOpen ? styles.wrapperMenuOpen : null,
        )}
      >
        <div
          className={classnames(
            styles.content,
            styles.papersignContent,
            'px-8',
          )}
        >
          <Link to="/products/papersign" className={styles.logo}>
            <img
              alt="Papersign logo"
              src="/website/papersign/SubLogo/png/Papersign_Sub_Logo_Final.png"
            />
          </Link>
          <div className={styles.links}>
            {menuItems.map((item) => (
              <MenuItem
                item={item}
                key={item.title}
                isActive={activeSubMenu === item.title}
                setActiveSubMenu={setActiveSubMenu}
              />
            ))}
          </div>
          <div className={styles.mobileMenuButton}>
            <span onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? <FiX /> : <FiMenu />}
            </span>
          </div>
          <div className={styles.menuButtons}>
            {isTry ? (
              <Button yellow solid className="ml-3" href="/try">
                Try without signing up
              </Button>
            ) : (
              <Button
                yellow
                solid
                className="ml-3"
                href={'/register/papersign'}
              >
                {registerText}
              </Button>
            )}
          </div>
          <MobileMenu
            menu={menuItems}
            menuOpen={menuOpen}
            setMenuOpen={setMenuOpen}
            invert={invert}
            activeSubMenu={activeSubMenu}
            setActiveSubMenu={setActiveSubMenu}
            registerUrl={'/register/papersign'}
            registerText={registerText}
          />
        </div>
      </div>
      {menuItems.map((item) => (
        <SubMenu
          key={item.title}
          isOpen={activeSubMenu === item.title && item.title != ''}
          title={item.title}
          subMenu={item.sub_menu}
          integrations={item.integrations}
          helpMenu={item.help_menu}
          featuredItem={item.featured_item}
          setActiveSubMenu={setActiveSubMenu}
        />
      ))}
    </>
  );
};

export default Nav2;
